/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Divider, Form, notification } from 'antd';
import { useTranslation } from 'react-i18next';
import {
    ArrowLeftOutlined,
    ArrowRightOutlined,
    InfoCircleOutlined,
} from '@ant-design/icons';
import Sticky from 'react-sticky-el';
import parse from 'html-react-parser';

import BtnSave from './BtnSave';
import Editor from '../../../../components/Shared/forms/EditorPrivacy';
import { INIT } from './init';
import { useEffect, useRef, useState } from 'react';
import { checkValidForm } from './Step1';
import { POLICY_NAME } from '../../POLICY';
import { DateTime } from 'luxon';
import moment from 'moment';

const Step2 = (props) => {
    const { t } = useTranslation(['translation', POLICY_NAME.CCTV_POLICY]);
    const [haveError, setHaveError] = useState(false);

    const onNextStep = () => {
        if (props.passStep) {
            props.nextStep();
            props?.form
                .validateFields()
                .then(() => {
                    props.setStep2(true);
                    setHaveError(false);
                })
                .catch(() => {
                    props.setStep2(false);
                    setHaveError(true);
                });
        } else setHaveError(true);
    };

    const onPreviousStep = () => {
        props.previousStep();
    };

    useEffect(() => {
        if (props?.previewData?.documentContent) {
            onValuesChange(null, props.previewData?.documentContent);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props?.previewData]);

    const onValuesChange = (change, allValues) => {
        const fields = ['dpaDetailDocument'];
        const check = checkValidForm(fields, allValues);
        props.setStep2(check);
    };

    const divRef = useRef(null);

    const handleSelectAllAndCopy = () => {
        if (divRef.current) {
            const range = document.createRange();
            range.selectNode(divRef.current);
            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
            document.execCommand('copy');
            selection.removeAllRanges();
            notification['success']({
                message: 'Copy to clipboard',
                // description: 'Copy to clipboard',
            });
        }
    };

    const requiredInformation = props?.requiredInformation;
    const contractDate = DateTime.fromISO(
        moment(requiredInformation?.contractDate).toISOString(),
        {
            locale: 'th',
        }
    ).toLocaleString(DateTime.DATE_FULL);

    return (
        <div className="px-4 block_">
            <div className="text-purple-PHX font-semibold text-2xl">
                เนื้อหาเอกสารสัญญาประมวลผลข้อมูลส่วนบุคคล
            </div>
            <div className="text-gray-500 text-tiny">
                เริ่มกรอกนโยบายของคุณได้เลย
            </div>
            <Divider />
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                onValuesChange={onValuesChange}
                name="documentContent"
                layout="vertical"
                form={props?.form}
                initialValues={INIT.documentContent}
            >
                {/* Introduction */}
                <div>
                    <div className="font-semibold text-xl mb-2">
                        เนื้อหาเอกสารสัญญา&nbsp;
                        <span className="text-[#F0536F]">*</span>
                    </div>

                    <div className="text-sm font-semibold">
                        {t('Example Data')}
                    </div>

                    <div className="relative">
                        <a
                            onClick={handleSelectAllAndCopy}
                            className="absolute right-4 top-4"
                        >
                            <svg
                                width={23}
                                height={23}
                                viewBox="0 0 23 23"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M5.75 5.87219V15.0938C5.74986 16.0062 6.09677 16.8845 6.72037 17.5505C7.34397 18.2165 8.19756 18.6205 9.108 18.6803L9.34375 18.6875H15.6889C15.5403 19.1078 15.265 19.4718 14.901 19.7292C14.537 19.9867 14.1021 20.1249 13.6562 20.125H8.625C7.48125 20.125 6.38435 19.6706 5.5756 18.8619C4.76685 18.0531 4.3125 16.9562 4.3125 15.8125V7.90625C4.31227 7.46016 4.4504 7.02497 4.70785 6.66067C4.96531 6.29637 5.32942 6.02089 5.75 5.87219ZM16.5312 2.875C17.1031 2.875 17.6516 3.10218 18.0559 3.50655C18.4603 3.91093 18.6875 4.45938 18.6875 5.03125V15.0938C18.6875 15.6656 18.4603 16.2141 18.0559 16.6184C17.6516 17.0228 17.1031 17.25 16.5312 17.25H9.34375C8.77188 17.25 8.22343 17.0228 7.81905 16.6184C7.41468 16.2141 7.1875 15.6656 7.1875 15.0938V5.03125C7.1875 4.45938 7.41468 3.91093 7.81905 3.50655C8.22343 3.10218 8.77188 2.875 9.34375 2.875H16.5312Z"
                                    fill="#7B67FB"
                                />
                            </svg>
                        </a>
                        <div
                            ref={divRef}
                            className="bg-[#F4F6FC] p-2 my-4 rounded-md max-h-190 overflow-y-auto"
                        >
                            <p style={{ textAlign: 'center' }}>
                                <strong>{requiredInformation?.dpaName}</strong>
                            </p>
                            <p style={{ textAlign: 'center' }}>
                                <strong>
                                    โครงการ&nbsp;
                                    {requiredInformation?.mainContractName}
                                    <br />
                                    ระหว่าง
                                    <br />
                                    {requiredInformation?.ownerCompanyName}
                                    &nbsp; กับ&nbsp;
                                    {
                                        requiredInformation?.counterpartyCompanyName
                                    }
                                </strong>
                            </p>
                            <p>
                                สัญญาประมวลผลข้อมูลส่วนบุคคลฉบับนี้ (“สัญญา”)
                                ทำขึ้น เมื่อวันที่ {contractDate} ระหว่าง&nbsp;
                                {requiredInformation?.ownerCompanyName}
                                &nbsp;สำนักงานตั้งอยู่ที่&nbsp;
                                {requiredInformation?.ownerCompanyAddress} โดย
                                {
                                    requiredInformation?.ownerFullName
                                } ตำแหน่ง {requiredInformation?.ownerPosition}
                                &nbsp; เป็นผู้มีอำนาจกระทำการแทน
                                ต่อไปนี้เรียกว่า (“บริษัท”) กับ&nbsp;
                                {requiredInformation?.counterpartyCompanyName}
                                &nbsp; สำนักงานตั้งอยู่ที่&nbsp;
                                {
                                    requiredInformation?.counterpartyCompanyAddress
                                }
                                &nbsp; โดย&nbsp;
                                {requiredInformation?.counterpartyFullName}
                                &nbsp; ตำแหน่ง&nbsp;
                                {requiredInformation?.counterpartyPosition}
                                &nbsp; เป็นผู้มีอำนาจกระทำการแทน
                                ต่อไปนี้เรียกว่า (“ผู้ประมวลผลข้อมูลส่วนบุคคล”)
                            </p>
                            <p>
                                {requiredInformation?.ownerCompanyName}&nbsp;
                                ในฐานะผู้ควบคุมข้อมูลส่วนบุคคลเป็นผู้มีอำนาจตัดสินใจ
                                กำหนดรูปแบบและกำหนดวัตถุประสงค์ในการประมวลผลข้อมูลส่วนบุคคล
                                ได้มอบหมายให้&nbsp;
                                {requiredInformation?.counterpartyCompanyName}
                                &nbsp; ในฐานะผู้ประมวลผลข้อมูลส่วนบุคคล
                                ดำเนินการเพื่อวัตถุประสงค์ดังต่อไปนี้
                            </p>
                            <p>{parse(`${requiredInformation?.purpose}`)}</p>
                            <p>
                                โดยข้อมูลส่วนบุคคลที่&nbsp;
                                {requiredInformation?.ownerCompanyName}&nbsp;
                                มอบหมายให้&nbsp;
                                {requiredInformation?.counterpartyCompanyName}
                                &nbsp; ประมวลผล ประกอบด้วย
                            </p>
                            <p>
                                {parse(`${requiredInformation?.personalData}`)}
                            </p>
                            <p>
                                ด้วยเหตุนี้
                                คู่สัญญาทั้งสองฝ่ายจึงตกลงเข้าทำสัญญาฉบับนี้เพื่อกำหนดสิทธิและหน้าที่ในการคุ้มครองข้อมูลส่วนบุคคล
                                เพื่อดำเนินการให้เป็นไปตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล
                                พ.ศ. 2562 และกฎหมายอื่น ๆ
                                ที่ออกตามความในพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล
                                พ.ศ. 2562 ซึ่งต่อไปในข้อตกลงฉบับนี้ รวมเรียกว่า
                                “กฎหมายคุ้มครองข้อมูลส่วนบุคคล”
                                ทั้งที่มีผลใช้บังคับอยู่ ณ
                                วันทำข้อตกลงฉบับนี้และที่จะมีการเพิ่มเติมหรือแก้ไขเปลี่ยนแปลงในภายหลัง
                                โดยมีรายละเอียดดังนี้
                            </p>
                            <p>
                                <strong>
                                    ข้อ 1. หน้าที่ของบริษัท
                                    ในฐานะผู้ควบคุมข้อมูล
                                </strong>
                            </p>
                            <p>
                                1.1
                                จัดให้มีมาตรการดูแลข้อมูลที่เหมาะสมและเจาะจงเพื่อคุ้มครองสิทธิเสรีภาพและประโยชน์ของเจ้าของข้อมูลส่วนบุคคลโดยเฉพาะการรักษาความลับของข้อมูลส่วนบุคคลตามหน้าที่หรือตามจริยธรรมแห่งวิชาชีพ
                                และประเมินความเสี่ยงและโอกาสที่อาจจะเกิดความเสี่ยงที่จะมีผลกระทบต่อสิทธิและเสรีภาพของเจ้าของข้อมูลส่วนบุคคล
                            </p>
                            <p>
                                1.2
                                จัดให้มีมาตรการรักษาความมั่นคงปลอดภัยที่เหมาะสม
                                เพื่อป้องกันการสูญหาย เข้าถึง ใช้ เปลี่ยนแปลง
                                แก้ไข
                                หรือเปิดเผยข้อมูลส่วนบุคคลโดยปราศจากอำนาจหรือโดยมิชอบ
                                และต้องทบทวน
                                มาตรการดังกล่าวเมื่อมีความจำเป็นหรือเมื่อเทคโนโลยีเปลี่ยนแปลงไปเพื่อให้มีประสิทธิภาพในการรักษาความมั่นคงปลอดภัยที่เหมาะสม
                                โดยมีมาตรการป้องกันด้านการบริหารจัดการ
                                (administrative safeguard)
                                มาตรการป้องกันด้านเทคนิค (technical safeguard)
                                มาตรการป้องกันทางกายภาพ (physical safeguard)
                                ในเรื่องการเข้าถึงหรือควบคุมการใช้งานข้อมูลส่วนบุคคล
                                (access control) ให้เป็นไปตามมาตรา 37 (1)
                                ตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ.
                                2562
                            </p>
                            <p>
                                1.3
                                จัดให้มีระบบการตรวจสอบเพื่อดำเนินการลบหรือทำลายข้อมูลส่วนบุคคลเมื่อพ้นกำหนดระยะเวลาการเก็บรักษา
                                หรือที่ไม่เกี่ยวข้องหรือเกินความจำเป็นตามวัตถุประสงค์ในการเก็บรวบรวมข้อมูลส่วนบุคคลนั้น
                                หรือตามที่เจ้าของข้อมูลส่วนบุคคลร้องขอ
                                หรือที่เจ้าของข้อมูลส่วนบุคคลได้ถอนความยินยอม
                                เว้นแต่เก็บรักษาไว้เพื่อวัตถุประสงค์ในการใช้เสรีภาพในการแสดงความคิดเห็นการเก็บรักษาไว้&nbsp;
                            </p>
                            <p>
                                1.4 ประเมินก่อนส่งมอบข้อมูลดำเนินการตรวจสอบสิทธิ
                                อำนาจหน้าที่ วัตถุประสงค์ในการนำข้อมูลไปใช้งาน
                                และฐานกฎหมายที่&nbsp;
                                {requiredInformation?.counterpartyCompanyName}
                                &nbsp; ใช้เพื่อร้องขอข้อมูลส่วนบุคคล
                            </p>
                            <p>
                                1.5 เมื่อส่งมอบข้อมูล&nbsp;
                                {requiredInformation?.ownerCompanyName}&nbsp;
                                จัดเตรียมข้อมูลใหม่จากข้อมูลดิบให้มีระดับรายละเอียดเท่าที่จำเป็นต่อจุดประสงค์การใช้งาน
                                พร้อมทำการบันทึกชื่อผู้ขอข้อมูล
                                ข้อมูลสำหรับติดต่อ วัน-เดือน-ปี ที่ให้ข้อมูล
                                ฐานกฎหมายที่ใช้สำหรับเข้าถึงข้อมูลส่วนบุคคล
                                ตลอดจนวัตถุประสงค์การนำไปใช้งาน และแจ้งให้&nbsp;
                                {requiredInformation?.counterpartyCompanyName}
                                &nbsp; ทราบว่าเมื่อรับข้อมูลไปแล้ว
                                ผู้รับข้อมูลจะต้องดำเนินการตามหน้าที่ของผู้ควบคุมข้อมูลส่วนบุคคลสำหรับข้อมูลชุดที่ร้องขอไปนั้นเช่นเดียวกัน
                                ตามขอบเขตและวัตถุประสงค์การใช้งานที่แจ้งไว้
                            </p>
                            <p>
                                1.6 หลังส่งมอบข้อมูลแก่&nbsp;
                                {requiredInformation?.counterpartyCompanyName}
                                &nbsp;
                                แล้วมีการติดตามการใช้งานเป็นครั้งคราว&nbsp;
                                {requiredInformation?.trackUsage}&nbsp;
                                เพื่อบันทึกสถานะล่าสุดในการใช้งานข้อมูลนั้น
                                หากไม่มีความจำเป็นใช้งานตามวัตถุประสงค์ที่แจ้งไว้เดิม
                                {requiredInformation?.ownerCompanyName}&nbsp;
                                จะแจ้งให้ลบทำลายข้อมูล
                                และกำหนดวิธีการในการปรับปรุงข้อมูลให้ทันสมัยต่อการใช้งานของผู้ใช้อยู่เสมอ
                            </p>
                            <p>
                                <strong>
                                    ข้อ 2. หน้าที่ของผู้ประมวลผลข้อมูลส่วนบุคคล
                                </strong>
                            </p>
                            <p>
                                2.1&nbsp;
                                {requiredInformation?.counterpartyCompanyName}
                                &nbsp; รับทราบว่า ข้อมูลส่วนบุคคล หมายถึง
                                ข้อมูลเกี่ยวกับบุคคลธรรมดาซึ่งทำให้สามารถระบุตัวบุคคลนั้นได้ไม่ว่าทางตรงหรือทางอ้อม
                                โดย&nbsp;
                                {requiredInformation?.counterpartyCompanyName}
                                &nbsp; จะดำเนินการ
                                ตามที่กฎหมายคุ้มครองข้อมูลส่วนบุคคลกำหนด
                                เพื่อคุ้มครองให้การประมวลผลข้อมูลส่วนบุคคลเป็นไปอย่างเหมาะสมและถูกต้องตามกฎหมาย
                                <br />
                                โดยในการดำเนินการตามข้อตกลงนี้&nbsp;
                                {requiredInformation?.counterpartyCompanyName}
                                &nbsp;
                                จะประมวลผลข้อมูลส่วนบุคคลเมื่อได้รับคำสั่งที่เป็นลายลักษณ์อักษรจาก&nbsp;
                                {requiredInformation?.ownerCompanyName}&nbsp;
                                แล้วเท่านั้น ทั้งนี้ เพื่อให้ปราศจากข้อสงสัย
                                การดำเนินการประมวลผลข้อมูลส่วนบุคคลโดย&nbsp;
                                {requiredInformation?.counterpartyCompanyName}
                                &nbsp; ตามหน้าที่และความรับผิดชอบตาม&nbsp;
                                {requiredInformation?.mainContractName}&nbsp;
                                ถือเป็นการได้รับคำสั่งที่เป็นลายลักษณ์อักษรจาก&nbsp;
                                {requiredInformation?.ownerCompanyName} แล้ว
                            </p>
                            <p>
                                2.2&nbsp;
                                {requiredInformation?.counterpartyCompanyName}
                                &nbsp;
                                จะกำหนดให้การเข้าถึงข้อมูลส่วนบุคคลภายใต้ข้อตกลงฉบับนี้ถูกจำกัดเฉพาะเจ้าหน้าที่
                                และ/หรือลูกจ้าง ตัวแทนหรือบุคคลใด ๆ
                                ที่ได้รับมอบหมาย
                                มีหน้าที่เกี่ยวข้องหรือมีความจำเป็นในการเข้าถึงข้อมูลส่วนบุคคลภายใต้ข้อตกลงฉบับนี้เท่านั้น
                                และจะดำเนินการเพื่อให้พนักงาน และ/หรือลูกจ้าง
                                ตัวแทนหรือบุคคลใด ๆ ที่ได้รับมอบหมายจาก&nbsp;
                                {requiredInformation?.counterpartyCompanyName}
                                &nbsp;
                                ทำการประมวลผลและรักษาความลับของข้อมูลส่วนบุคคลด้วยมาตรฐานเดียวกัน
                            </p>
                            <p>
                                2.3&nbsp;
                                {requiredInformation?.counterpartyCompanyName}
                                &nbsp; จะควบคุมดูแลให้เจ้าหน้าที่
                                และ/หรือลูกจ้าง ตัวแทนหรือบุคคลใด ๆ
                                ที่ปฏิบัติหน้าที่ในการประมวลผลข้อมูลส่วนบุคคล
                                ปฏิบัติตามกฎหมายคุ้มครองข้อมูลส่วนบุคคลอย่างเคร่งครัด
                                และดำเนินการประมวลผลข้อมูลส่วนบุคคลตามวัตถุประสงค์ของการดำเนินการตามข้อตกลงฉบับนี้เท่านั้น
                                โดยจะไม่ทำซ้ำ คัดลอก ทำสำเนา
                                บันทึกภาพข้อมูลส่วนบุคคลไม่ว่าทั้งหมดหรือแต่บางส่วนเป็นอันขาด
                                เว้นแต่เป็นไปตามเงื่อนไขของบันทึกความร่วมมือหรือสัญญา
                                หรือกฎหมายที่เกี่ยวข้องจะระบุหรือบัญญัติไว้เป็นประการอื่น
                            </p>
                            <p>
                                2.4&nbsp;
                                {requiredInformation?.counterpartyCompanyName}
                                &nbsp;
                                จะดำเนินการเพื่อช่วยเหลือหรือสนับสนุน&nbsp;
                                {requiredInformation?.ownerCompanyName}&nbsp;
                                ในการตอบสนองต่อคำร้องที่เจ้าของข้อมูลส่วนบุคคลแจ้งต่อ&nbsp;
                                {requiredInformation?.ownerCompanyName}&nbsp;
                                อันเป็นการใช้สิทธิของเจ้าของข้อมูลส่วนบุคคลตามกฎหมายคุ้มครองข้อมูลส่วนบุคคลในส่วนที่เกี่ยวข้องกับการประมวลผลข้อมูลส่วนบุคคลในขอบเขตของข้อตกลงฉบับนี้
                                อย่างไรก็ดี
                                ในกรณีที่เจ้าของข้อมูลส่วนบุคคลยื่นคำร้องขอใช้สิทธิดังกล่าวต่อ&nbsp;
                                {requiredInformation?.counterpartyCompanyName}
                                &nbsp; โดยตรง&nbsp;
                                {requiredInformation?.counterpartyCompanyName}
                                &nbsp;
                                จะดำเนินการแจ้งและส่งคำร้องดังกล่าวให้แก่&nbsp;
                                {requiredInformation?.ownerCompanyName} ทันที
                                โดย&nbsp;
                                {requiredInformation?.counterpartyCompanyName}
                                &nbsp; จะไม่เป็นผู้ตอบสนองต่อคำร้องดังกล่าว
                                เว้นแต่&nbsp;
                                {requiredInformation?.ownerCompanyName}&nbsp;
                                จะได้มอบหมายให้&nbsp;
                                {requiredInformation?.counterpartyCompanyName}
                                &nbsp;
                                ดำเนินการเฉพาะเรื่องที่เกี่ยวข้องกับคำร้องดังกล่าว
                            </p>
                            <p>
                                2.5&nbsp;
                                {requiredInformation?.counterpartyCompanyName}
                                &nbsp;
                                จะจัดทำและเก็บรักษาบันทึกรายการของกิจกรรมการประมวลผลข้อมูลส่วนบุคคล
                                (Record of Processing) ทั้งหมดที่&nbsp;
                                {requiredInformation?.counterpartyCompanyName}
                                &nbsp; ประมวลผลในขอบเขตของข้อตกลงฉบับนี้
                                และจะดำเนินการส่งมอบบันทึกรายการดังกล่าวให้แก่&nbsp;
                                {requiredInformation?.ownerCompanyName}&nbsp;
                                {requiredInformation?.frequencyForSendRopa}
                                &nbsp;และ/หรือทันทีที่&nbsp;
                                {requiredInformation?.ownerCompanyName} ร้องขอ
                            </p>
                            <p>
                                2.6&nbsp;
                                {requiredInformation?.counterpartyCompanyName}
                                &nbsp;
                                จะจัดให้มีและคงไว้ซึ่งมาตรการรักษาความปลอดภัยสำหรับการประมวลผลข้อมูลที่มีความเหมาะสมทั้งในเชิงองค์กรและเชิงเทคนิคตามที่คณะกรรมการคุ้มครองข้อมูลส่วนบุคคลได้ประกาศกำหนดและ/หรือตามมาตรฐานสากล
                                โดยคำนึงถึงลักษณะ ขอบเขต
                                และวัตถุประสงค์ของการประมวลผลข้อมูลตามที่กำหนดในข้อตกลงฉบับนี้เป็นสำคัญ
                                เพื่อคุ้มครองข้อมูลส่วนบุคคลจากความเสี่ยงอันเกี่ยวเนื่องกับการประมวลผลข้อมูลส่วนบุคคล
                                เช่น ความเสียหายอันเกิดจากการละเมิด อุบัติเหตุ
                                การลบ ทำลาย สูญหาย เปลี่ยนแปลง แก้ไข เข้าถึง ใช้
                                เปิดเผยหรือโอนข้อมูลส่วนบุคคลโดยไม่ชอบด้วยกฎหมาย
                                เป็นต้น
                            </p>
                            <p>
                                2.7
                                เว้นแต่กฎหมายที่เกี่ยวข้องจะบัญญัติไว้เป็นประการอื่น&nbsp;
                                {requiredInformation?.counterpartyCompanyName}
                                &nbsp;
                                จะทำการลบหรือทำลายข้อมูลส่วนบุคคลที่ทำการประมวลผลภายใต้ข้อตกลงฉบับนี้ภายใน&nbsp;
                                {requiredInformation?.amtDestroyData} วัน
                                นับแต่วันที่ดำเนินการประมวลผลเสร็จสิ้น
                                หรือวันที่&nbsp;
                                {requiredInformation?.ownerCompanyName}&nbsp;
                                และ&nbsp;
                                {requiredInformation?.counterpartyCompanyName}
                                &nbsp;ได้ตกลงเป็นลายลักษณ์อักษรให้ยกเลิก&nbsp;
                                {requiredInformation?.mainContractName}&nbsp;
                                แล้วแต่กรณีใดจะเกิดขึ้นก่อน
                                <br />
                                นอกจากนี้ ในกรณีปรากฎว่า&nbsp;
                                {requiredInformation?.counterpartyCompanyName}
                                &nbsp;
                                หมดความจำเป็นจะต้องเก็บรักษาข้อมูลส่วนบุคคลตามข้อตกลงฉบับนี้ก่อนสิ้นระยะเวลาตามวรรคหนึ่ง&nbsp;
                                {requiredInformation?.counterpartyCompanyName}
                                &nbsp;
                                จะทำการลบหรือทำลายข้อมูลส่วนบุคคลตามข้อตกลงฉบับนี้ทันที
                            </p>
                            <p>
                                <strong>
                                    ข้อ 3.
                                    เมื่อเกิดเหตุกระทบต่อการรักษาความปลอดภัยของข้อมูลส่วนบุคคล
                                </strong>
                            </p>

                            <p>
                                3.1 กรณีที่&nbsp;
                                {requiredInformation?.counterpartyCompanyName}
                                &nbsp; พบพฤติการณ์ใด ๆ
                                ที่มีลักษณะที่กระทบต่อการรักษาความปลอดภัยของข้อมูลส่วนบุคคลที่&nbsp;
                                {requiredInformation?.counterpartyCompanyName}
                                &nbsp; ประมวลผลภายใต้ข้อตกลงฉบับนี้
                                ซึ่งอาจก่อให้เกิดความเสียหายจากการละเมิด
                                อุบัติเหตุ การลบ ทำลาย สูญหาย เปลี่ยนแปลง แก้ไข
                                เข้าถึง ใช้
                                เปิดเผยหรือโอนข้อมูลส่วนบุคคลโดยไม่ชอบด้วยกฎหมาย
                                แล้ว&nbsp;
                                {requiredInformation?.counterpartyCompanyName}
                                &nbsp; จะดำเนินการแจ้งให้&nbsp;
                                {requiredInformation?.ownerCompanyName}&nbsp;
                                ทราบโดยทันทีภายในเวลาไม่เกิน 24 ชั่วโมงหรือ 48
                                ชั่วโมง ทั้งนี้ไม่ควรเกิน 48 ชั่วโมง
                                เนื่องจาก&nbsp;
                                {requiredInformation?.ownerCompanyName}&nbsp;
                                ในฐานะผู้ควบคุมข้อมูลส่วนบุคคลมีหน้าที่ต้องแจ้งเหตุดังกล่าวแก่คณะกรรมการคุ้มครองข้อมูลส่วนบุคคลภายใน
                                72 ชั่วโมง
                            </p>
                            <p>
                                3.2
                                การแจ้งถึงเหตุการณ์ละเมิดข้อมูลส่วนบุคคลที่เกิดขึ้นภายใต้ข้อตกลงนี้&nbsp;
                                {requiredInformation?.counterpartyCompanyName}
                                &nbsp;
                                จะใช้มาตรการตามที่เห็นสมควรในการระบุถึงสาเหตุของการละเมิด
                                และป้องกันปัญหาดังกล่าวมิให้เกิดซ้ำ
                                และจะให้ข้อมูลแก่&nbsp;
                                {requiredInformation?.ownerCompanyName}&nbsp;
                                ภายใต้ขอบเขตที่กฎหมายคุ้มครองข้อมูลส่วนบุคคลได้กำหนด
                                ดังต่อไปนี้
                                <br /> •
                                รายละเอียดของลักษณะและผลกระทบที่อาจเกิดขึ้นของการละเมิด
                                <br />
                                • มาตรการที่ถูกใช้เพื่อลดผลกระทบของการละเมิด
                                <br />
                                •
                                ประเภทของข้อมูลส่วนบุคคลและเจ้าของข้อมูลส่วนบุคคลที่ถูกละเมิด
                                หากมีปรากฏ
                                <br /> • ข้อมูลอื่น ๆ เกี่ยวข้องกับการละเมิด
                            </p>
                            <p>3.3 สัญญาฉบับนี้นี้อยู่ภายใต้กฎหมายไทย</p>
                            <p>
                                3.4 ข้อพิพาทใด ๆ ที่เกี่ยวข้องกับสัญญาฉบับนี้
                                ซึ่งคู่สัญญาทั้งสองฝ่ายไม่สามารถยุติลงได้
                                คู่สัญญาทั้งสองฝ่ายตกลงให้ศาลไทยเป็นศาลที่มีเขตอำนาจ
                            </p>
                            <p>
                                <strong>ข้อ 4. ข้อกำหนดทั่วไป</strong>
                            </p>
                            <p>
                                4.1 การรักษาความลับ
                                <br />
                                คู่สัญญาทั้งสองฝ่ายตกลงเก็บรักษาสัญญา
                                และข้อมูลที่ได้รับจากคู่สัญญาภายใต้สัญญาฉบับนี้
                                (“ข้อมูลที่เป็นความลับ”) ไว้เป็นความลับ
                                และจะต้องไม่ใช้หรือเปิดเผยข้อมูลที่เป็นความลับนี้
                                โดยไม่ได้รับความยินยอมเป็นลายลักษณ์อักษรล่วงหน้าจากคู่สัญญาอีกฝ่าย
                                เว้นแต่:
                                <br />
                                (ก) กฎหมายกำหนดให้เปิดเผย
                                <br />
                                (ข) เป็นข้อมูลที่เปิดเผยแก่สาธารณะแล้ว
                            </p>
                            <p>
                                4.2 การแจ้ง
                                <br />
                                การแจ้ง
                                และการสื่อสารทั้งหมดภายใต้สัญญาฉบับนี้จะต้องทำเป็นลายลักษณ์อักษร
                                และจะต้องจัดส่งทางอีเมลหรือทางไปรษณีย์ที่ระบุไว้ตามสัญญาฉบับนี้
                                ซึ่งที่อยู่อาจมีการแก้ไขเปลี่ยนแปลงได้เป็นครั้งคราว
                            </p>
                            <p>
                                <strong>ข้อ 5. การบังคับใช้สัญญา</strong>
                            </p>
                            <p>
                                หน้าที่และความรับผิดของ&nbsp;
                                {requiredInformation?.counterpartyCompanyName}
                                &nbsp;
                                ในการปฏิบัติตามข้อตกลงจะสิ้นสุดลงนับแต่วันที่ปฏิบัติงานที่ตกลงเสร็จสิ้น
                                หรือ วันที่&nbsp;
                                {requiredInformation?.counterpartyCompanyName}
                                &nbsp; และ&nbsp;
                                {requiredInformation?.ownerCompanyName}&nbsp;
                                ได้ตกลงเป็นลายลักษณ์อักษรให้ยกเลิก&nbsp;
                                {requiredInformation?.mainContractName}&nbsp;
                                แล้วแต่กรณีใดจะเกิดขึ้นก่อน อย่างไรก็ดี
                                การสิ้นผลลงของข้อตกลงนี้
                                ไม่กระทบต่อหน้าที่ของ&nbsp;
                                {requiredInformation?.counterpartyCompanyName}
                                &nbsp;
                                ในการลบหรือทำลายข้อมูลส่วนบุคคลตามที่ได้กำหนดในข้อ
                                2.7 ของข้อตกลงฉบับนี้
                                <br />
                                ทั้งสองฝ่ายได้อ่านและเข้าใจข้อความโดยละเอียดตลอดแล้ว
                                เพื่อเป็นหลักฐานแห่งการนี้
                                ทั้งสองฝ่ายจึงได้ลงนามไว้เป็นหลักฐานต่อหน้าพยาน
                                ณ วันที่ {contractDate}
                            </p>
                        </div>
                    </div>

                    <Form.Item
                        className="mt-4"
                        name="dpaDetailDocument"
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                    >
                        <Editor
                            size="large"
                            rows={4}
                            placeholder={t('Content', { lang: 'TH' })}
                        />
                    </Form.Item>
                </div>

                <Sticky
                    mode="bottom"
                    boundaryElement=".block_"
                    stickyClassName="bg-white p-4 shadow h-16 rounded-lg z-50"
                >
                    <div className="flex items-center">
                        <Button
                            type="default"
                            size="large"
                            onClick={onPreviousStep}
                        >
                            <ArrowLeftOutlined /> {t('policy.PreviousStep')}
                        </Button>
                        <Button
                            type="primary"
                            size="large"
                            onClick={onNextStep}
                            className="ml-4"
                        >
                            {t('Preview before publishing')}&nbsp;
                            <ArrowRightOutlined />
                        </Button>
                        <BtnSave
                            loading={props.loadingSaveDraft}
                            saveDraft={props.saveDraft}
                        />
                    </div>
                    {haveError && (
                        <div className="text-red-500 space-x-2 mt-2">
                            <InfoCircleOutlined />
                            <span>
                                {t(
                                    'Unable to preview before release Please complete the required information on each tab'
                                )}
                            </span>
                        </div>
                    )}
                </Sticky>
            </Form>
        </div>
    );
};

export default Step2;
